import { getJSON, postJSON, putJSON, deleteAction } from './httpService.js';
const STORAGE_KEY = 'vg.client.matching';

export const searchKeywords = (filters) => {
  return getJSON(`/matching/keywordSearch?${filters.join('&')}`);
};

export const searchCriteria = (filters) => {
  return getJSON(`/matching/criteriaSearch?${filters.join('&')}`);
};

export const adminSearchCriteria = (type, filters) => {
  return getJSON(`/matching/criteria/${type}/search?${filters.join('&')}`);
};

export const searchRoles = (filters) =>
  getJSON(`/matching/criteria/role/search?${filters.join('&')}`);

export const searchSkills = (filters) => {
  return getJSON(`/matching/criteria/skill/search?${filters.join('&')}`);
};

export const searchTools = (filters) => {
  return getJSON(`/matching/criteria/tool/search?${filters.join('&')}`);
};

export const searchStyles = (filters) => {
  return getJSON(`/matching/criteria/style/search?${filters.join('&')}`);
};

export const getRole = (role) => getJSON(`/matching/criteria/role/${role}`);

export const getFullRoles = () => getJSON(`/matching/criteria/role/full`);

export const saveRole = (role, isNew) =>
  isNew
    ? postJSON(`/matching/criteria/role/`, role)
    : putJSON(`/matching/criteria/role/${role.value}`, role);

export const deleteRole = (role) =>
  deleteAction(`/matching/criteria/role/${role}`);

export const getSkill = (skill) => getJSON(`/matching/criteria/skill/${skill}`);

export const saveSkill = (skill, isNew) =>
  isNew
    ? postJSON(`/matching/criteria/skill/`, skill)
    : putJSON(`/matching/criteria/skill/${skill.value}`, skill);

export const deleteSkill = (skill) =>
  deleteAction(`/matching/criteria/skill/${skill}`);

export const getTool = (tool) => getJSON(`/matching/criteria/tool/${tool}`);

export const saveTool = (tool, isNew) =>
  isNew
    ? postJSON(`/matching/criteria/tool/`, tool)
    : putJSON(`/matching/criteria/tool/${tool.value}`, tool);

export const deleteTool = (tool) =>
  deleteAction(`/matching/criteria/tool/${tool}`);

export const createCriteriaLink = (payload) =>
  postJSON(`/matching/criteriaLink`, payload);

export const deleteCriteriaLink = (criteria) =>
  deleteAction(`/matching/criteriaLink?${criteria.join('&')}`);

export const updateState = (payload) => {
  let matchingState = getStoredState();
  matchingState = { ...matchingState, ...payload };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(matchingState));
};

export const emptyMatchingState = () => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({}));
};

const getStoredState = () => {
  try {
    let localState = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (typeof localState.query?.hours === 'string') {
      localState.query.hours = localState.query.hours.split(',');
    }
    if (typeof localState.query?.rids === 'string') {
      localState.query.rids = localState.query.rids.split(',');
    }
    return localState;
  } catch {
    return {};
  }
};

export const getState = () => getStoredState();

export const getSuggestedCriteria = (query) =>
  getJSON(`/matching/criteria/suggestions?${query}`);
